<template>
  <div class="svg-button">
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
   viewBox="0 0 1500 900" style="enable-background:new 0 0 1500 900;" xml:space="preserve">

<svg>
<g id="btn_canto1" v-on:click="cambiar_canto(1)">
  <path class="st0" d="M613,244.5c-6.3,0-11.5-5.2-11.5-11.5V89c0-6.3,5.2-11.5,11.5-11.5h273c6.3,0,11.5,5.2,11.5,11.5v144
    c0,6.3-5.2,11.5-11.5,11.5H613z"/>
  <path class="st0" d="M886,78c6.1,0,11,4.9,11,11v144c0,6.1-4.9,11-11,11H613c-6.1,0-11-4.9-11-11V89c0-6.1,4.9-11,11-11H886
     M886,77H613c-6.6,0-12,5.4-12,12v144c0,6.6,5.4,12,12,12h273c6.6,0,12-5.4,12-12V89C898,82.4,892.6,77,886,77L886,77z"/>
</g>
</svg>
<g id="btn_canto2" v-on:click="cambiar_canto(2)">
  <path class="st0" d="M613,867.5c-6.3,0-11.5-5.2-11.5-11.5V712c0-6.3,5.2-11.5,11.5-11.5h273c6.3,0,11.5,5.2,11.5,11.5v144
    c0,6.3-5.2,11.5-11.5,11.5H613z"/>
  <path class="st1" d="M886,701c6.1,0,11,4.9,11,11v144c0,6.1-4.9,11-11,11H613c-6.1,0-11-4.9-11-11V712c0-6.1,4.9-11,11-11H886
     M886,700H613c-6.6,0-12,5.4-12,12v144c0,6.6,5.4,12,12,12h273c6.6,0,12-5.4,12-12V712C898,705.4,892.6,700,886,700L886,700z"/>
</g>
<g id="btn_canto3" v-on:click="cambiar_canto(3)">
  <path class="st0" d="M70,529.5c-6.3,0-11.5-5.2-11.5-11.5V374c0-6.3,5.2-11.5,11.5-11.5h273c6.3,0,11.5,5.2,11.5,11.5v144
    c0,6.3-5.2,11.5-11.5,11.5H70z"/>
  <path class="st1" d="M343,363c6.1,0,11,4.9,11,11v144c0,6.1-4.9,11-11,11H70c-6.1,0-11-4.9-11-11V374c0-6.1,4.9-11,11-11H343
     M343,362H70c-6.6,0-12,5.4-12,12v144c0,6.6,5.4,12,12,12h273c6.6,0,12-5.4,12-12V374C355,367.4,349.6,362,343,362L343,362z"/>
</g>
<g id="btn_canto4" v-on:click="cambiar_canto(4)">
  <path class="st0" d="M1201,529.5c-6.3,0-11.5-5.2-11.5-11.5V374c0-6.3,5.2-11.5,11.5-11.5h273c6.3,0,11.5,5.2,11.5,11.5v144
    c0,6.3-5.2,11.5-11.5,11.5H1201z"/>
  <path class="st1" d="M1474,363c6.1,0,11,4.9,11,11v144c0,6.1-4.9,11-11,11h-273c-6.1,0-11-4.9-11-11V374c0-6.1,4.9-11,11-11H1474
     M1474,362h-273c-6.6,0-12,5.4-12,12v144c0,6.6,5.4,12,12,12h273c6.6,0,12-5.4,12-12V374C1486,367.4,1480.6,362,1474,362L1474,362z
    "/>
</g>
<g>
  <rect :class="clasecanto1"  x="428" y="298" width="688" height="11"/>
</g>
<g>
  <rect :class="clasecanto2" x="428" y="604" class="st3" width="688" height="11"/>
</g>
<rect :class="clasecanto3" x="428" y="325" width="11" height="264"/>
<rect :class="clasecanto4" x="1101" y="325" width="11" height="264"/>

<Canto3 :valor="getcanto3"></Canto3>
<Canto4 :valor="getcanto4"></Canto4>


<Canto1 :valor="getcanto1"></Canto1>
<Canto2 :valor="getcanto2"></Canto2>
<Giro :valor="getgiro"></Giro>

<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
  </div>
</template>

<!-- =================================================
 Vue Script
================================================== -->
<script>

import Canto1 from './Canto1.vue'
import Canto2 from './Canto2.vue'
import Canto3 from './Canto3.vue'
import Canto4 from './Canto4.vue'
import Giro from './Giro.vue'
export default {
  name: 'svg-button',
  components: { Canto1, Canto2, Canto3, Canto4, Giro },
  data () {
    return {
      isActive: false
    }
  },
  computed: {
    clasecanto1 () {
      if (this.$store.getters.estadocanto1 === 1) {
        return 'fillazul'
      } else if (this.$store.getters.estadocanto1 === 2) {
        return 'fillrojo'
      } else {
        return 'fillgris'
      }
    },
    clasecanto2 () {
      if (this.$store.getters.estadocanto2 === 1) {
        return 'fillazul'
      } else if (this.$store.getters.estadocanto2 === 2) {
        return 'fillrojo'
      } else {
        return 'fillgris'
      }
    },
    clasecanto3 () {
      if (this.$store.getters.estadocanto3 === 1) {
        return 'fillazul'
      } else if (this.$store.getters.estadocanto3 === 2) {
        return 'fillrojo'
      } else {
        return 'fillgris'
      }
    },
    clasecanto4 () {
      if (this.$store.getters.estadocanto4 === 1) {
        return 'fillazul'
      } else if (this.$store.getters.estadocanto4 === 2) {
        return 'fillrojo'
      } else {
        return 'fillgris'
      }
    },
    getcanto1: function () {
      return this.$store.getters.estadocanto1
    },
    getcanto2: function () {
      return this.$store.getters.estadocanto2
    },
    getcanto3: function () {
      return this.$store.getters.estadocanto3
    },
    getcanto4: function () {
      return this.$store.getters.estadocanto4
    },
    getgiro: function () {
      return this.$store.getters.giro
    }
  },
  methods: {
    cambiar_canto (data) {
      this.$store.dispatch('CAMBIAR_CANTO', data)
    }
  }
}
</script>
<style>
.st0{fill:#305884;}
  .st1{fill:#305884;}
  .st2{fill:#d2d2d2;}
  .st3{fill:#FF0000;}
  .st4{fill:#0000FF;}
  .st5{fill:#FFFFFF;}
  .st6{fill:#FFFFFF;}
  .st7{fill:#FFFFFF;}
  .st8{fill:#FFFFFF;}
  .st9{fill:#D80027;}
  .fillgris{fill:#d2d2d2;}
  .fillazul{fill:#0000FF;}
  .fillrojo{fill:#FF0000;}
  .fillverde{fill:#91dc5a;}
</style>


// WEBPACK FOOTER //
// src/components/Cantostodos.vue